module.exports = __webpack_public_path__ + "img/logo-light.fb93373d.svg";